// extracted by css-extract-rspack-plugin
export default {"root":"h7UtcV","show-more":"Qq8aTW","showMore":"Qq8aTW"};